import { lazy } from "react";
import { Navigate, RouteObject } from "react-router-dom";

const Attendees = lazy(() => import("@/pages/admin/Conference/Attendees/Attendees"));
const TicketDetail = lazy(() => import("@/pages/admin/Conference/TicketDetail/TicketDetail"));
const Shirts = lazy(() => import("@/pages/admin/Conference/Shirts/Shirts"));
const Inventory = lazy(() => import("@/pages/admin/Conference/Inventory/Inventory"));
const FlightBlocks = lazy(() => import("@/pages/admin/Conference/FlightBlocks/FlightBlocks"));

// This year's conference (replaces ladmin's Conference Tickets screens). Past years are under conference-archive.
// Attendees, Flights and Rooms are one grid with different columns; `key` keeps their filters apart
const conferenceRoutes: RouteObject[] = [
  { index: true, element: <Navigate to="attendees" replace /> },
  {
    path: "attendees",
    children: [
      { index: true, element: <Attendees key="attendees" view="attendees" /> },
      { path: "new", element: <TicketDetail key="new" /> },
      { path: ":id", element: <TicketDetail key="edit" /> },
    ],
  },
  { path: "flights", element: <Attendees key="flights" view="flights" /> },
  { path: "flight-blocks", element: <FlightBlocks /> },
  { path: "rooms", element: <Attendees key="rooms" view="rooms" /> },
  { path: "shirts", element: <Shirts /> },
  { path: "inventory", element: <Inventory /> },
];

export default conferenceRoutes;
